import { Component, Input, OnInit } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { faCircleQuestion } from '@ng-icons/font-awesome/regular';
import { faSolidXmark } from '@ng-icons/font-awesome/solid';

@Component({
    selector: 'app-explainer-text',
    imports: [NgIcon],
    templateUrl: './explainer-text.component.html',
    styleUrl: './explainer-text.component.scss',
    providers: [provideIcons({ faCircleQuestion, faSolidXmark })]
})
export class ExplainerTextComponent implements OnInit {
  @Input()
  heading?: string;

  @Input()
  id?: string;

  dismissed?: boolean = false;

  ngOnInit(): void {
    if(!this.id){
      throw new Error('ExplainerText requires a unique ID, none given');
    }
    if(localStorage.getItem(`expl-dismissed-${this.id}`)){
      this.dismissed = true;
    }
  }

  dismiss() {
    localStorage.setItem(`expl-dismissed-${this.id}`, "true");
    this.dismissed = true;
  }

  undismiss() {
    localStorage.removeItem(`expl-dismissed-${this.id}`);
    this.dismissed = false;
  }
}
